export const MOBILE_BREAKPOINT = 700;

export const DEFAULT_SURVEY_TITLE = "Untitled Procedure Template";

export const BLOCK_FIELDS = {
  id: "id",
  type: "type",
  question: "question",
  choices: "choices",
  isRequired: "isRequired",
  isDescriptionRequired: "isDescriptionRequired",
  description: "description",
  commentsOnScale: "commentsOnScale",
};

export const TITLE_ELEMENT_ID = "887ajOp";
